<div class="ratings-dropdown">
  <div class="d-flex align-items-center justify-content-between">
    <h2>{{ orderBillingHeading }}</h2>
    <a
      class="link"
      (click)="redirectToAllBilling()"
      style="margin-right: 15px"
      >{{ allComments }}</a
    >
  </div>
  <p-scrollpanel [style]="{ width: '100%', height: '300px' }">
    <div class="scroll-padding">
      <div
        class="review-col globalborder-btm-header pt-2 pb-2"
        *ngFor="let item of orderNotesGridListing">
        <p [title]="item.note" class="feedback-notes">
          {{ item.note }}
        </p>
        <div class="meta d-flex justify-content-between cstm-colm">
          <div class="reviewer-name d-flex align-items-center me-3">
            <p class="name m-0 p-0">{{ item.createdBy }}</p>
          </div>
          <div class="d-flex date-switcher">
            <p
              class="me-3 m-0 p-0"
              *ngIf="item?.createdDate | hidedynamicsdate">
              {{ item.createdDate | date: "MM-dd-yyyy" }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </p-scrollpanel>
</div>

<jni-modal-stacker
  *ngIf="orderNotesDisplayModal"
  [displayModal]="orderNotesDisplayModal"
  (closeEvent)="closeModalForOrderNotes()">
  <h1 class="panelHeading">Billing Notes</h1>
  <div class="panelBody">
    <!--To Do-->
    <!-- <jni-invoice-preview-order-notes
      [orderNotesGridListing]="orderNotesGridListing"
      (scrollHiddenStatus)="addScollHiddenClass()"
    ></jni-invoice-preview-order-notes> -->
  </div>
</jni-modal-stacker>
